import { defineComponent as _defineComponent } from 'vue'
import { PaymentMethodDetails } from '@/@types/billing/subscription/PaymentMethodDetails';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentMethod',
  props: {
    payment: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})